var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnderlyingInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 336,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 376,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 416,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 86h-20c-5.522 0-10 4.477-10 10s4.478 10 10 10h20c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156 86h-20c-5.522 0-10 4.477-10 10s4.478 10 10 10h20c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 86h-20c-5.522 0-10 4.477-10 10s4.478 10 10 10h20c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442 86h-146c-5.522 0-10 4.477-10 10s4.478 10 10 10h146c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 416v-195.858l20-20v15.858c0 5.523 4.478 10 10 10s10-4.477 10-10v-40c0-5.523-4.478-10-10-10h-40c-5.522 0-10 4.477-10 10s4.478 9.99 10 9.99h15.858c-9.909 9.909-80.71 80.721-95.858 95.868l-32.929-32.929c-3.931-3.931-10.288-3.855-14.143 0l-80 80c-1.874 1.875-2.928 4.419-2.928 7.071v80c0 5.523 4.478 10 10 10h200c5.522 0 10-4.477 10-10zm-180-10h-20v-65.858l20-20zm40 0h-20v-105.858l20-20zm40 0h-20v-125.858l20 20zm40 0h-20v-105.857l20-20zm40 0h-20v-145.858l20-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116 166c-5.522 0-10 4.477-10 10v11.72c-11.639 4.128-20 15.243-20 28.28 0 16.542 13.458 30 30 30 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.175 0-6.092-1.46-8.004-4.006-3.318-4.416-9.586-5.308-14.002-1.99-4.416 3.317-5.307 9.585-1.99 14.001 3.575 4.759 8.489 8.298 13.996 10.255v11.74c0 5.523 4.478 10 10 10s10-4.477 10-10v-11.72c11.639-4.128 20-15.243 20-28.28 0-16.542-13.458-30-30-30-5.514 0-10-4.486-10-10s4.486-10 10-10c3.175 0 6.092 1.46 8.004 4.006 3.318 4.415 9.586 5.307 14.002 1.99s5.307-9.585 1.99-14.001c-3.575-4.759-8.489-8.298-13.996-10.255v-11.74c0-5.523-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 406h-92c-5.522 0-10 4.477-10 10s4.478 10 10 10h92c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 366h-92c-5.522 0-10 4.477-10 10s4.478 10 10 10h92c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 326h-92c-5.522 0-10 4.477-10 10s4.478 10 10 10h92c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 456,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 466h201c5.522 0 10-4.477 10-10s-4.478-10-10-10h-191v-300h472v300h-191c-5.522 0-10 4.477-10 10s4.478 10 10 10h201c5.522 0 10-4.477 10-10v-400c0-5.523-4.478-10-10-10h-492c-5.522 0-10 4.477-10 10v400c0 5.523 4.478 10 10 10zm10-400h472v60h-472z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlyingInfo);
export default __webpack_public_path__ + "static/media/underlying-info.ec500aa0.svg";
export { ForwardRef as ReactComponent };